<template>
  <v-row no-gutters class="h100">
    <template v-if="products.length === 2">
      <template v-for="(product, index) in products">
        <v-col
          cols="6"
          v-if="index === 1"
          :key="`empty-before-${index}`"
        />

        <v-col
          cols="6"
          :key="index"
          v-if="index < 3 || (products.length <= 4 && index <= 4)"
        >
          <product-image
            :alt-text="product.name"
            :image="product.image"
            :width="148"
            :height="148"
          />
        </v-col>

        <v-col
          cols="6"
          v-if="index === 0"
          :key="`empty-after-${index}`"
        />
      </template>
    </template>

    <template v-else>
      <template v-for="(product, index) in products">
        <v-col
          cols="6"
          :key="index"
          v-if="index < 3 || (products.length <= 4 && index <= 4)"
        >
          <product-image
            :alt-text="product.name"
            :image="product.image"
            :width="148"
            :height="148"
          />
        </v-col>
      </template>

      <v-col
        cols="6"
        class="d-flex"
        v-if="products.length > 4"
      >
        <div class="kit-images-grid__overflow">
          +{{ products.length - 3 }}
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import ProductImage from './ProductImage.vue'

export default {
  name: 'KitImagesGrid',
  components: { ProductImage },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.kit-images-grid__overflow {
  width: 126px;
  height: 126px;
  background-color: #DFF3F2;
  border-radius: 50%;
  margin: auto;

  display: grid;
  place-items: center;

  font-family: 'Lato-Regular', sans-serif;
  font-size: 45px;
  color: #16181f;
}
</style>
